import axiosInstance from '@/utils/api.js'

var state = {
  systemGroups: [],
  infoGroup: {
    fids: []
  },
  fids: [],
  initWebTabItems: [
    {
      name: 'Main',
      items: [
        {
          name: 'Customers',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users',
              '/api/users/web_settings',
              '/api/users/users_count',
              '/api/users/card_pools',
              '/api/users/users_list',
              '/api/settings/additionalparams',
              '/api/users/full_info',
              '/api/users/contacts',
              '/api/referencebooks/banks',
              '/api/referencebooks/houses',
              '/api/referencebooks/currencies',
              '/api/settings/routers',
              '/api/settings/documents/profiles',
              '/api/users/systemusersshort',
              '/api/users/groups',
              '/api/tariffing/accounting_periods',
              '/api/tariffing/services',
              '/api/tariffing/tariffs',
              '/api/tariffing/charge_polices',
              '/api/tariffing/coefficient_scheme',
              '/api/users/total_bonus',
              '/api/settings/documents/templates',
              '/api/users/contracts',
              '/api/users/accounts',
              '/api/users/servicelinks',
              '/api/users/tarifflinks',
              '/api/settings/tech_params',
              '/api/settings/tech_params_slinks',
              '/api/users/access_cards',
              '/api/referencebooks/paymentmethods',
              '/api/reports/payments',
              '/api/reports/funds_flows',
              '/api/reports/burning_payments',
              '/api/reports/other_charges',
              '/api/reports/invoices_doc_list',
              '/api/reports/general',
              '/api/reports/services',
              '/api/reports/custom_services',
              '/api/reports/traffic',
              '/api/reports/traffic_detailed',
              '/api/reports/telephony',
              '/api/reports/tel_directions',
              '/api/reports/blocks',
              '/api/reports/users_log',
              '/api/reports/sessions',
              '/api/reports/dhcp_leases',
              '/api/users/contracts/download',
              '/api/users/irdeto/activate',
              '/api/users/irdeto/deactivate',
              '/api/users/irdeto/pair_chipset',
              '/api/users/irdeto/unpair_all_chipsets',
              '/api/users/irdeto/overwrite_parental_pin_code',
              '/api/users/irdeto/overwrite_synchronize',
              '/api/inventory/switches',
              '/api/inventory/dhcp_pools',
              '/api/tariffing/tclasses',
              '/api/settings/netflow_providers',
              '/api/settings/custom_isg_attrs',
              '/api/settings/ippools',
              '/api/settings/attr_tunnel_types',
              '/api/users/servicelinks/periodic',
              '/api/users/servicelinks/once',
              '/api/tariffing/radius_attrs',
              '/api/users/servicelinks/iptraffic',
              '/api/tariffing/services/iptv',
              '/api/users/servicelinks/iptv',
              '/api/tariffing/services/vod',
              '/api/users/servicelinks/telephony',
              '/api/users/servicelinks/hotspot',
              '/api/users/servicelinks/dialup',
              '/api/users/servicelinks/freezed',
              '/api/users/services_in_tariff_link',
              '/api/users/tech_params',
              '/api/tariffing/promised_payments',
              '/api/users/documents',
              '/api/settings/registry_settings_form',
              '/api/referencebooks/free_ips_for_house',
              '/api/referencebooks/free_ips_for_house_by_uid',
              '/api/inventory/switch_ports_usage',
              '/api/referencebooks/banks_search',
              '/api/settings/system_vat_tax',
              '/api/settings/core_time',
              '/api/tariffing/services/charge_policy',
              '/api/tariffing/tariffs_history',
              '/api/tariffing/coefficient_schedule',
              '/api/users/blocks_info',
              '/api/users/accounts_groups_by_aid',
              '/api/users/invoices',
              '/api/users/accounts_all_groups'
            ],
            post: [
              '/api/users',
              '/api/users/short_search',
              '/api/users/contacts',
              '/api/users/contracts',
              '/api/users/contracts/upload',
              '/api/users/accounts',
              '/api/users/accounts/search',
              '/api/users/servicelinks/once',
              '/api/users/servicelinks/periodic',
              '/api/users/servicelinks/iptraffic',
              '/api/users/servicelinks/iptv',
              '/api/tariffing/services/vod',
              '/api/users/servicelinks/telephony',
              '/api/users/servicelinks/hotspot',
              '/api/users/servicelinks/dialup',
              '/api/users/servicelinks/freezed',
              '/api/users/tarifflinks',
              '/api/users/tech_params',
              '/api/users/access_card',
              '/api/tariffing/payments',
              '/api/tariffing/promised_payments',
              '/api/tariffing/coefficient_schedule',
              '/api/users/link_groups_to_account',
              '/api/users/extended_search'
            ],
            put: [
              '/api/users',
              '/api/users/accounts',
              '/api/tariffing/radius_attrs',
              '/api/users/servicelinks/periodic',
              '/api/users/servicelinks/once',
              '/api/users/servicelinks/iptraffic',
              '/api/users/servicelinks/iptv',
              '/api/tariffing/services/vod',
              '/api/users/servicelinks/telephony',
              '/api/users/servicelinks/hotspot',
              '/api/users/servicelinks/dialup',
              '/api/users/servicelinks/freezed',
              '/api/users/tech_params',
              '/api/users/change_account_balance',
              '/api/users/lifestream_id'
            ],
            delete: [
              '/api/users',
              '/api/users/contracts',
              '/api/users/accounts',
              '/api/users/servicelinks',
              '/api/users/tech_params',
              '/api/users/access_card',
              '/api/users/tarifflinks',
              '/api/additional/radius_session',
              '/api/users/',
              '/api/users/blocks'
            ]
          }
        },
        {
          name: 'System users',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/system_users',
              '/api/users/system_groups'
            ],
            post: [
              '/api/users/system_users'
            ],
            put: [
              '/api/users/system_users'
            ],
            delete: [
              '/api/users/system_users'
            ]
          }
        },
        {
          name: 'Accounts',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/irdeto/activate',
              '/api/users/irdeto/deactivate',
              '/api/users/irdeto/pair_chipset',
              '/api/users/irdeto/unpair_all_chipsets',
              '/api/users/irdeto/overwrite_parental_pin_code',
              '/api/users/irdeto/overwrite_synchronize'
            ],
            post: [
              '/api/users/accounts/search'
            ],
            put: [
              '/api/users/accounts'
            ]
          }
        },
        {
          name: 'Card pools',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/card_pools',
              '/api/referencebooks/currencies',
              '/api/users/systemusersshort',
              '/api/tariffing/tariffs',
              '/api/users/card_pool',
              '/api/settings/registry_settings_form'
            ],
            post: [
              '/api/users/card_pool',
              '/api/users/card_pool_owner'
            ],
            put: [
              '/api/users/block_card',
              '/api/users/unblock_card',
              '/api/users/clear_expired_card'
            ],
            delete: [
              '/api/users/card_pool_owner'
            ]
          }
        },
        {
          name: 'Accounts groups',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/accounts_groups',
              '/api/users/accounts_group',
              '/api/users/list_accounts'
            ],
            post: [
              '/api/users/accounts_groups',
              '/api/users/link_account_group'
            ],
            put: [
              '/api/users/accounts_groups',
              '/api/users/unlink_accounts_group'
            ],
            delete: [
              '/api/users/accounts_groups'
            ]
          }
        },
        {
          name: 'Groups',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/groups',
              '/api/users/group_info'
            ],
            post: [
              '/api/users/groups'
            ],
            put: [
              '/api/users/groups'
            ],
            delete: [
              '/api/users/groups',
              '/api/users/user_from_group'
            ]
          }
        },
        {
          name: 'System groups',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/system_groups',
              '/api/permissions',
              '/api/users/system_group',
              '/api/routes',
              '/api/users/fids'
            ],
            post: [
              '/api/users/system_groups',
              '/api/permissions'
            ],
            put: [
              '/api/users/system_groups'
            ]
          }
        },
        {
          name: 'Support',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/who_am_i',
              '/api/users',
              '/api/users/systemusersshort'
            ],
            put: [
              '/api/dashboard/tech_support_chat'
            ]
          }
        },
        {
          name: 'General information',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/systemusersshort',
              '/api/settings/license',
              '/api/dashboard/ram_stat',
              '/api/dashboard/top_processes',
              '/api/dashboard/db_stats',
              '/api/dashboard/cp_connections',
              '/api/dashboard/core_build_info',
              '/api/dashboard/rest_connections',
              '/api/users/web_settings',
              '/api/dashboard/radius_sessions',
              '/api/dashboard/server_stats',
              '/api/dashboard/db_processes',
              '/api/dashboard/core_connections',
              '/api/dashboard/stat_created_users',
              '/api/dashboard/tariffs_history_graphic',
              '/api/dashboard/tariffs_history',
              '/api/dashboard/hotspot_sessions',
              '/api/dashboard/stat_deleted_users'
            ],
            put: [
              '/api/additional/drop_radius_session',
              '/api/additional/disconnect_radius_session'
            ]
          }
        },
        {
          name: 'Archived users',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/deleted_users'
            ],
            post: [
              '/api/users/restore_user',
              '/api/users/deleted_search'
            ]
          }
        }
      ]
    },
    {
      name: 'Reference book',
      items: [
        {
          name: 'Payments methods',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/referencebooks/paymentmethods'
            ],
            post: [
              '/api/referencebooks/paymentmethods'
            ],
            put: [
              '/api/referencebooks/paymentmethods'
            ]
          }
        },
        {
          name: 'Currency',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/referencebooks/currencies',
              '/api/reports/currency_rate_rbc'
            ],
            post: [
              '/api/referencebooks/currencies'
            ],
            put: [
              '/api/referencebooks/currencies'
            ],
            delete: [
              '/api/referencebooks/currencies'
            ]
          }
        },
        {
          name: 'IP zone',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/referencebooks/ip_zones',
              '/api/referencebooks/ip_zones_paged'
            ],
            post: [
              '/api/referencebooks/ip_zones'
            ],
            put: [
              '/api/referencebooks/ip_zones'
            ]
          }
        },
        {
          name: 'Buildings',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/referencebooks/houses',
              '/api/referencebooks/houses_paged',
              '/api/referencebooks/ip_zones',
              '/api/referencebooks/streets'
            ],
            post: [
              '/api/referencebooks/houses'
            ],
            put: [
              '/api/referencebooks/houses'
            ],
            delete: [
              '/api/referencebooks/houses'
            ]
          }
        },
        {
          name: 'Streets',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/referencebooks/streets'
            ],
            post: [
              '/api/referencebooks/streets'
            ],
            put: [
              '/api/referencebooks/streets'
            ],
            delete: [
              '/api/referencebooks/streets'
            ]
          }
        },
        {
          name: 'Banks',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/referencebooks/banks',
              '/api/referencebooks/banks_search'
            ],
            post: [
              '/api/referencebooks/banks'
            ],
            put: [
              '/api/referencebooks/banks'
            ],
            delete: [
              '/api/referencebooks/banks'
            ]
          }
        },
        {
          name: 'Companies',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/referencebooks/banks',
              '/api/tariffing/suppliers',
              '/api/settings/supplier'
            ],
            post: [
              '/api/settings/suppliers'
            ],
            put: [
              '/api/settings/suppliers'
            ],
            delete: [
              '/api/settings/suppliers'
            ]
          }
        }
      ]
    },
    {
      name: 'Reports',
      items: [
        {
          name: 'Payments',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/groups',
              '/api/referencebooks/paymentmethods',
              '/api/referencebooks/currencies',
              '/api/users/systemusersshort',
              '/api/reports/payments',
              '/api/reports/payment_orders',
              '/api/reports/funds_flows',
              '/api/reports/burning_payments',
              '/api/reports/other_charges',
              '/api/reports/invoices_doc_list'
            ],
            put: [
              '/api/users/cancel_payment'
            ]
          }
        },
        {
          name: 'Services',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/groups',
              '/api/reports/general',
              '/api/reports/services',
              '/api/reports/custom_services',
              '/api/reports/traffic',
              '/api/settings/collectors',
              '/api/reports/request_traffic_detailed',
              '/api/reports/traffic_detailed',
              '/api/reports/telephony',
              '/api/reports/tel_directions'
            ]
          }
        },
        {
          name: 'OtherReport',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users',
              '/api/users/groups',
              '/api/reports/blocks',
              '/api/users/systemusersshort',
              '/api/reports/users_log',
              '/api/reports/sessions',
              '/api/reports/dhcp_leases'
            ]
          }
        }
      ]
    },
    {
      name: 'Tariffication',
      items: [
        {
          name: 'Services',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/tclasses',
              '/api/settings/attr_tunnel_types',
              '/api/tariffing/tel_zones',
              '/api/tariffing/services',
              '/api/users/groups',
              '/api/tariffing/contract_types',
              '/api/tariffing/suppliers',
              '/api/tariffing/charge_polices',
              '/api/tariffing/coefficient_scheme',
              '/api/tariffing/media_groups',
              '/api/tariffing/media_contents',
              '/api/settings/ippools',
              '/api/tariffing/time_ranges',
              '/api/tariffing/services/once',
              '/api/tariffing/services/periodic',
              '/api/tariffing/radius_attrs',
              '/api/tariffing/services/iptraffic',
              '/api/tariffing/services/hotspot',
              '/api/tariffing/services/dialup',
              '/api/tariffing/services/telephony',
              '/api/tariffing/services/iptv',
              '/api/tariffing/services/vod',
              '/api/tariffing/services/freezed'
            ],
            post: [
              '/api/tariffing/services/once',
              '/api/tariffing/services/periodic',
              '/api/tariffing/services/iptraffic',
              '/api/tariffing/services/hotspot',
              '/api/tariffing/services/dialup',
              '/api/tariffing/services/telephony',
              '/api/tariffing/services/iptv',
              '/api/tariffing/services/vod',
              '/api/tariffing/services/freezed'
            ],
            put: [
              '/api/tariffing/get_tel_directions',
              '/api/tariffing/services/set_supplier_id',
              '/api/tariffing/services/once',
              '/api/tariffing/services/set_charge_policy',
              '/api/tariffing/services/periodic',
              '/api/tariffing/radius_attrs',
              '/api/tariffing/services/hotspot',
              '/api/tariffing/services/dialup',
              '/api/tariffing/services/telephony',
              '/api/tariffing/services/iptv',
              '/api/tariffing/services/vod',
              '/api/tariffing/services/freezed',
              '/api/tariffing/services/iptraffic'
            ],
            delete: [
              '/api/tariffing/services'
            ]
          }
        },
        {
          name: 'Services templates',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/tclasses',
              '/api/settings/attr_tunnel_types',
              '/api/tariffing/tel_zones',
              '/api/tariffing/services',
              '/api/users/groups',
              '/api/tariffing/contract_types',
              '/api/tariffing/suppliers',
              '/api/tariffing/charge_polices',
              '/api/tariffing/coefficient_scheme',
              '/api/tariffing/media_groups',
              '/api/tariffing/media_contents',
              '/api/settings/ippools',
              '/api/tariffing/time_ranges',
              '/api/tariffing/services/once',
              '/api/tariffing/services/periodic',
              '/api/tariffing/radius_attrs',
              '/api/tariffing/services/iptraffic',
              '/api/tariffing/services/hotspot',
              '/api/tariffing/services/dialup',
              '/api/tariffing/services/telephony',
              '/api/tariffing/services/iptv',
              '/api/tariffing/services/vod',
              '/api/tariffing/services/freezed'
            ],
            post: [
              '/api/tariffing/services/once',
              '/api/tariffing/services/periodic',
              '/api/tariffing/services/iptraffic',
              '/api/tariffing/services/hotspot',
              '/api/tariffing/services/dialup',
              '/api/tariffing/services/telephony',
              '/api/tariffing/services/iptv',
              '/api/tariffing/services/vod',
              '/api/tariffing/services/freezed'
            ],
            put: [
              '/api/tariffing/get_tel_directions',
              '/api/tariffing/services/set_supplier_id',
              '/api/tariffing/services/once',
              '/api/tariffing/services/set_charge_policy',
              '/api/tariffing/services/periodic',
              '/api/tariffing/radius_attrs',
              '/api/tariffing/services/hotspot',
              '/api/tariffing/services/dialup',
              '/api/tariffing/services/telephony',
              '/api/tariffing/services/iptv',
              '/api/tariffing/services/vod',
              '/api/tariffing/services/freezed',
              '/api/tariffing/services/set_multi_linking',
              '/api/tariffing/hotspot_networks'
            ],
            delete: [
              '/api/tariffing/services'
            ]
          }
        },
        {
          name: 'Services in tariffs',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/tclasses',
              '/api/settings/attr_tunnel_types',
              '/api/tariffing/tel_zones',
              '/api/tariffing/services',
              '/api/users/groups',
              '/api/tariffing/contract_types',
              '/api/tariffing/suppliers',
              '/api/tariffing/charge_polices',
              '/api/tariffing/coefficient_scheme',
              '/api/tariffing/media_groups',
              '/api/tariffing/media_contents',
              '/api/settings/ippools',
              '/api/tariffing/time_ranges',
              '/api/tariffing/services/once',
              '/api/tariffing/services/periodic',
              '/api/tariffing/radius_attrs',
              '/api/tariffing/services/iptraffic',
              '/api/tariffing/services/hotspot',
              '/api/tariffing/services/dialup',
              '/api/tariffing/services/telephony',
              '/api/tariffing/services/iptv',
              '/api/tariffing/services/vod',
              '/api/tariffing/services/freezed',
              '/api/tariffing/services/links_count'
            ],
            put: [
              '/api/tariffing/get_tel_directions',
              '/api/tariffing/services/set_supplier_id',
              '/api/tariffing/services/once',
              '/api/tariffing/services/set_charge_policy',
              '/api/tariffing/services/periodic',
              '/api/tariffing/radius_attrs',
              '/api/tariffing/services/hotspot',
              '/api/tariffing/services/dialup',
              '/api/tariffing/services/telephony',
              '/api/tariffing/services/iptv',
              '/api/tariffing/services/vod',
              '/api/tariffing/services/freezed',
              '/api/tariffing/services/set_multi_linking'
            ],
            delete: [
              '/api/tariffing/services'
            ]
          }
        },
        {
          name: 'Tariffs',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/tclasses',
              '/api/settings/attr_tunnel_types',
              '/api/tariffing/tel_zones',
              '/api/tariffing/services',
              '/api/users/groups',
              '/api/tariffing/contract_types',
              '/api/tariffing/suppliers',
              '/api/tariffing/charge_polices',
              '/api/tariffing/coefficient_scheme',
              '/api/tariffing/media_groups',
              '/api/tariffing/media_contents',
              '/api/settings/ippools',
              '/api/tariffing/time_ranges',
              '/api/tariffing/time_ranges',
              '/api/tariffing/tariffs',
              '/api/users/systemusersshort',
              '/api/tariffing/radius_attrs',
              '/api/tariffing/services/once',
              '/api/tariffing/services/periodic',
              '/api/tariffing/services/iptraffic',
              '/api/tariffing/services/hotspot',
              '/api/tariffing/services/dialup',
              '/api/tariffing/services/telephony',
              '/api/tariffing/services/iptv',
              '/api/tariffing/services/vod'
            ],
            post: [
              '/api/tariffing/tariff',
              '/api/tariffing/services/once',
              '/api/tariffing/services/periodic',
              '/api/tariffing/services/iptraffic',
              '/api/tariffing/services/hotspot',
              '/api/tariffing/services/dialup',
              '/api/tariffing/services/telephony',
              '/api/tariffing/services/iptv',
              '/api/tariffing/services/vod'
            ],
            put: [
              '/api/tariffing/get_tel_directions',
              '/api/tariffing/tariff',
              '/api/tariffing/services/set_supplier_id',
              '/api/tariffing/services/set_charge_policy',
              '/api/tariffing/services/set_multi_linking',
              '/api/tariffing/radius_attrs'
            ],
            delete: [
              '/api/tariffing/tariff',
              '/api/tariffing/delete_service_from_tariff'
            ]
          }
        },
        {
          name: 'Accounting periods',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/accounting_periods'
            ],
            post: [
              '/api/tariffing/accounting_period'
            ],
            put: [
              '/api/tariffing/accounting_period'
            ]
          }
        },
        {
          name: 'Charge policies',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/charge_polices'
            ],
            post: [
              '/api/tariffing/charge_policy'
            ],
            put: [
              '/api/tariffing/charge_policy'
            ],
            delete: [
              '/api/tariffing/charge_policy'
            ]
          }
        },
        {
          name: 'Coefficient scheme',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/coefficient_scheme'
            ],
            post: [
              '/api/tariffing/coefficient_scheme'
            ],
            put: [
              '/api/tariffing/coefficient_scheme'
            ],
            delete: [
              '/api/tariffing/coefficient_scheme'
            ]
          }
        },
        {
          name: 'Contract type',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/contract_types'
            ],
            post: [
              '/api/tariffing/contract_type'
            ],
            put: [
              '/api/tariffing/contract_type'
            ],
            delete: [
              '/api/tariffing/contract_type'
            ]
          }
        },
        {
          name: 'Time ranges',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/time_ranges'
            ],
            post: [
              '/api/tariffing/time_ranges'
            ],
            put: [
              '/api/tariffing/time_ranges'
            ],
            delete: [
              '/api/tariffing/time_ranges'
            ]
          }
        }
      ]
    },
    {
      name: 'Inventory',
      items: [
        {
          name: 'Profiles',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/inventory/switch_types'
            ],
            post: [
              '/api/inventory/switch_types'
            ],
            put: [
              '/api/inventory/switch_types'
            ],
            delete: [
              '/api/inventory/switch_types'
            ]
          }
        },
        {
          name: 'Switches',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/inventory/switches',
              '/api/inventory/switches_paged',
              '/api/inventory/switch_types',
              '/api/inventory/dhcp_pools',
              '/api/referencebooks/houses',
              '/api/inventory/dhcp_options',
              '/api/inventory/switch_ports_usage',
              '/api/inventory/dhcp_pool_links'
            ],
            post: [
              '/api/inventory/switches',
              '/api/inventory/dhcp_options'
            ],
            put: [
              '/api/inventory/dhcp_pool_links',
              '/api/inventory/switches'
            ],
            delete: [
              '/api/inventory/switches'
            ]
          }
        },
        {
          name: 'NetFlow providers',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/collectors',
              '/api/settings/netflow_providers'
            ],
            post: [
              '/api/settings/netflow_providers'
            ],
            put: [
              '/api/settings/netflow_providers'
            ],
            delete: [
              '/api/settings/netflow_providers'
            ]
          }
        },
        {
          name: 'Traffic collectors',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/collectors',
              '/api/settings/collector_stats'
            ],
            post: [
              '/api/settings/collectors'
            ],
            put: [
              '/api/settings/collectors'
            ],
            delete: [
              '/api/settings/collectors'
            ]
          }
        },
        {
          name: 'Firewalls',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/routers'
            ],
            post: [
              '/api/settings/routers'
            ],
            put: [
              '/api/settings/routers'
            ],
            delete: [
              '/api/settings/routers'
            ]
          }
        },
        {
          name: 'Firewall rules',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/rabbitmq_servers',
              '/api/settings/http_servers',
              '/api/settings/fw_rules',
              '/api/settings/routers',
              '/api/tariffing/tariffs',
              '/api/users/groups',
              '/api/settings/fw_subst'
            ],
            post: [
              '/api/settings/fw_rules'
            ],
            put: [
              '/api/settings/fw_rules'
            ],
            delete: [
              '/api/settings/fw_rules'
            ]
          }
        },
        {
          name: 'NAS list',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/nases',
              '/api/settings/isg_profiles',
              '/api/tariffing/radius_attrs',
              '/api/settings/attr_tunnel_types'
            ],
            post: [
              '/api/settings/nases'
            ],
            put: [
              '/api/settings/nases',
              '/api/tariffing/radius_attrs'
            ],
            delete: [
              '/api/settings/nases'
            ]
          }
        },
        {
          name: 'RabbitMQ servers',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/rabbitmq_servers'
            ],
            post: [
              '/api/settings/rabbitmq_servers'
            ],
            put: [
              '/api/settings/rabbitmq_servers'
            ],
            delete: [
              '/api/settings/rabbitmq_servers'
            ]
          }
        },
        {
          name: 'HTTP servers',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/http_servers'
            ],
            post: [
              '/api/settings/http_servers'
            ],
            put: [
              '/api/settings/http_servers'
            ],
            delete: [
              '/api/settings/http_servers'
            ]
          }
        }
      ]
    },
    {
      name: 'Systems',
      items: [
        {
          name: 'Main',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/registry_settings_group',
              '/api/settings/registry_settings_form'
            ],
            put: [
              '/api/settings/registry_setting'
            ]
          }
        },
        {
          name: 'AdditionalSet',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/additionalparams'
            ],
            post: [
              '/api/settings/additionalparams'
            ],
            put: [
              '/api/settings/additionalparams'
            ],
            delete: [
              '/api/settings/additionalparams'
            ]
          }
        },
        {
          name: 'Archive DB',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/db_archives',
              '/api/settings/db_archives_update',
              '/api/settings/db_archives_verify',
              '/api/settings/db_archives_schedule'

            ],
            post: [
              '/api/settings/db_archives',
              '/api/settings/db_archives_schedule'
            ],
            delete: [
              '/api/settings/db_archives_schedule'
            ],
            put: [
              '/api/settings/test_db_connection'
            ]
          }
        },
        {
          name: 'RADIUS accounts',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/radius_accounts',
              '/api/settings/attr_tunnel_types',
              '/api/tariffing/radius_attrs'
            ],
            post: [
              '/api/settings/radius_accounts'
            ],
            put: [
              '/api/tariffing/radius_attrs',
              '/api/settings/radius_accounts'
            ],
            delete: [
              '/api/settings/radius_accounts'
            ]
          }
        },
        {
          name: 'Dynamic shaping',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/shaping_services',
              '/api/tariffing/services',
              '/api/tariffing/time_ranges',
              '/api/tariffing/tclasses',
              '/api/tariffing/services/once',
              '/api/settings/shaping'
            ],
            post: [
              '/api/settings/shaping'
            ],
            put: [
              '/api/settings/shaping'
            ],
            delete: [
              '/api/settings/shaping'
            ]
          }
        }
      ]
    },
    {
      name: 'Customer portal',
      items: [
        {
          name: 'Switch tariff',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/tariffs',
              '/api/tariffing/services',
              '/api/settings/switch_tariffs',
              '/api/users/groups'
            ],
            post: [
              '/api/settings/switch_tariffs'
            ],
            put: [
              '/api/settings/switch_tariffs'
            ],
            delete: [
              '/api/settings/switch_tariffs'
            ]
          }
        },
        {
          name: 'Payment systems',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/payment_systems',
              '/api/referencebooks/currencies',
              '/api/settings/payment_systems_template',
              '/api/referencebooks/paymentmethods',
              '/api/users/groups',
              '/api/users/recurrent_payments'
            ],
            post: [
              '/api/settings/payment_systems'
            ],
            put: [
              '/api/settings/payment_systems'
            ],
            delete: [
              '/api/settings/payment_systems',
              '/api/users/recurrent_payments'
            ]
          }
        },
        {
          name: 'Promised payments',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/services',
              '/api/settings/promised_payments',
              '/api/users/groups',
              '/api/tariffing/services'
            ],
            post: [
              '/api/settings/promised_payments'
            ],
            put: [
              '/api/settings/promised_payments'
            ],
            delete: [
              '/api/settings/promised_payments'
            ]
          }
        },
        {
          name: 'Internal transfer',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/funds_flow_settings',
              '/api/users/groups'
            ],
            post: [
              '/api/settings/funds_flow_settings'
            ],
            put: [
              '/api/settings/funds_flow_settings'
            ],
            delete: [
              '/api/settings/funds_flow_settings'
            ]
          }
        },
        {
          name: 'Voluntary suspension',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/services',
              '/api/settings/voluntary_suspensions',
              '/api/users/groups',
              '/api/settings/all_voluntary_suspensions'
            ],
            post: [
              '/api/settings/voluntary_suspensions'
            ],
            put: [
              '/api/settings/voluntary_suspensions'
            ],
            delete: [
              '/api/settings/voluntary_suspensions',
              '/api/settings/customer_voluntary_suspension'
            ]
          }
        },
        {
          name: 'Services and tariffs connect',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/tariffs',
              '/api/tariffing/services',
              '/api/settings/independent_connect_services',
              '/api/users/groups',
              '/api/tariffing/accounting_periods',
              '/'
            ],
            post: [
              '/api/settings/independent_connect_services'
            ],
            put: [
              '/api/settings/independent_connect_services'
            ],
            delete: [
              '/api/settings/independent_connect_services'
            ]
          }
        },
        {
          name: 'Captive portal',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/captive_portal_udata_list',
              '/api/users/groups',
              '/api/tariffing/accounting_periods',
              '/api/tariffing/services'
            ],
            post: [
              '/api/settings/captive_portal_udata'
            ],
            put: [
              '/api/settings/captive_portal_udata'
            ],
            delete: [
              '/api/settings/captive_portal_udata'
            ]
          }
        },
        {
          name: 'Tech support chat',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/ts_chat_settings',
              '/api/users/groups',
              '/api/users/group_users'
            ],
            post: [
              '/api/settings/ts_chat_settings'
            ],
            put: [
              '/api/settings/ts_chat_settings'
            ],
            delete: [
              '/api/settings/ts_chat_settings'
            ]
          }
        },
        {
          name: 'Edit profile',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/edit_profile',
              '/api/users/groups',
              '/api/settings/registry_settings_form'
            ],
            post: [
              '/api/settings/edit_profile'
            ],
            put: [
              '/api/settings/registry_setting',
              '/api/settings/edit_profile'
            ],
            delete: [
              '/api/settings/edit_profile'
            ]
          }
        },
        {
          name: 'Rentsoft',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/tariffs',
              '/api/settings/rentsoft',
              '/api/users/groups',
              '/api/tariffing/accounting_periods',
              '/api/settings/registry_settings_form',
              '/'
            ],
            post: [
              '/api/settings/rentsoft'
            ],
            put: [
              '/api/settings/registry_setting',
              '/api/settings/rentsoft'
            ],
            delete: [
              '/api/settings/rentsoft'
            ]
          }
        },
        {
          name: 'Customer reports',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/registry_settings_form',
              '/api/settings/available_reports',
              '/api/users/groups'
            ],
            put: [
              '/api/settings/registry_setting',
              '/api/settings/available_reports'
            ],
            delete: [
              '/api/settings/available_reports'
            ]
          }
        },
        {
          name: 'Customer docs',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/available_docs',
              '/api/users/groups'
            ],
            put: [
              '/api/settings/available_docs'
            ],
            delete: [
              '/api/settings/available_docs'
            ]
          }
        },
        {
          name: '24TV',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/integrations/24tv/users',
              '/api/integrations/24tv/available_tariffs',
              '/api/settings/registry_settings_form',
              '/api/integrations/24tv/user_subscriptions'
            ],
            post: [
              '/api/integrations/24tv/pause_all_user_subscriptions',
              '/api/integrations/24tv/resume_all_user_subscription',
              '/api/integrations/24tv/pause_user_subscription',
              '/api/integrations/24tv/resume_user_subscription',
              '/api/integrations/24tv/add_user'
            ],
            put: [
              '/api/settings/registry_setting'
            ]
          }
        },
        {
          name: 'Activating card',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/available_activating_card',
              '/api/users/groups'
            ],
            post: [
              '/api/settings/available_activating_card'
            ],
            put: [
              '/api/settings/available_activating_card'
            ],
            delete: [
              '/api/settings/available_activating_card'
            ]
          }
        },
        {
          name: 'Socially significant resources',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/registry_settings_form'
            ],
            put: [
              '/api/settings/registry_setting'
            ]
          }
        }
      ]},
    {
      name: 'Documents',
      items: [
        {
          name: 'Document templates',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/documents/templates',
              '/api/settings/documents/template_download'
            ],
            post: [
              '/api/settings/documents/templates'
            ],
            put: [
              '/api/settings/documents/templates'
            ],
            delete: [
              '/api/settings/documents/templates'
            ]
          }
        },
        {
          name: 'Profiles of documents',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/documents/templates',
              '/api/settings/documents/profiles'
            ],
            post: [
              '/api/settings/documents/profiles'
            ],
            put: [
              '/api/settings/documents/profiles'
            ],
            delete: [
              '/api/settings/documents/profiles'
            ]
          }
        },
        {
          name: 'Replacements in document',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/documents/replacements'
            ],
            post: [
              '/api/settings/documents/replacements'
            ],
            put: [
              '/api/settings/documents/replacements'
            ],
            delete: [
              '/api/settings/documents/replacements'
            ]
          }
        }
      ]
    },
    {
      name: 'Network',
      items: [
        {
          name: 'ISG attributes',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/isg_attrs'
            ],
            post: [
              '/api/settings/isg_attrs'
            ],
            put: [
              '/api/settings/isg_attrs'
            ],
            delete: [
              '/api/settings/isg_attrs'
            ]
          }
        },
        {
          name: 'ISG profile',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/isg_profiles',
              '/api/inventory/switch_types',
              '/api/tariffing/services',
              '/api/settings/attr_tunnel_types',
              '/api/tariffing/radius_attrs'
            ],
            post: [
              '/api/settings/isg_profiles'
            ],
            put: [
              '/api/tariffing/radius_attrs',
              '/api/settings/isg_profiles',
              '/api/tariffing/radius_attrs_rewrite'
            ],
            delete: [
              '/api/settings/isg_profiles',
              '/api/tariffing/radius_attrs'
            ]
          }
        },
        {
          name: 'Traffic classes',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/tclasses',
              '/api/tariffing/time_ranges',
              '/api/settings/netflow_providers',
              '/api/tariffing/traffic_class'
            ],
            post: [
              '/api/tariffing/tclasses'
            ],
            put: [
              '/api/tariffing/tclasses'
            ],
            delete: [
              '/api/tariffing/tclasses'
            ]
          }
        },
        {
          name: 'IP pools',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/ippools'
            ],
            post: [
              '/api/settings/ippools'
            ],
            put: [
              '/api/settings/ippools'
            ],
            delete: [
              '/api/settings/ippools'
            ]
          }
        },
        {
          name: 'IP groups',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/ip_groups'
            ]
          }
        },
        {
          name: 'DHCPv4 pools',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/inventory/dhcp_pools',
              '/api/inventory/dhcp_options'
            ],
            post: [
              '/api/inventory/dhcp_pool',
              '/api/inventory/dhcp_options'
            ],
            put: [
              '/api/inventory/dhcp_pool'
            ],
            delete: [
              '/api/inventory/dhcp_options',
              '/api/inventory/dhcp_pool'
            ]
          }
        },
        {
          name: 'DHCPv4 leases',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/inventory/dhcp_leases',
              '/api/inventory/dhcp_leases_active',
              '/api/inventory/dhcp_leases_expired'
            ],
            put: [
              '/api/inventory/expire_dhcp_lease'
            ],
            delete: [
              '/api/inventory/dhcp_lease'
            ]
          }
        },
        {
          name: 'DHCPv6',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/dhcp6/config',
              '/settings/dhcp6/config_write'
            ],
            put: [
              '/api/settings/dhcp6/set_config'
            ]
          }
        },
        {
          name: 'Tunnel Radius Attributes',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/attr_tunnel_types'
            ],
            post: [
              '/api/settings/attr_tunnel_types'
            ],
            put: [
              '/api/settings/attr_tunnel_types'
            ],
            delete: [
              '/api/settings/attr_tunnel_types'
            ]
          }
        }
      ]
    },
    {
      name: 'TelephonyReports',
      items: [
        {
          name: 'Emergency calls',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/emergency_calls',
              '/api/tariffing/services',
              '/api/tariffing/tel_zones'
            ],
            post: [
              '/api/settings/emergency_calls'
            ],
            put: [
              '/api/tariffing/get_tel_directions'
            ],
            delete: [
              '/api/settings/emergency_calls'
            ]
          }
        },
        {
          name: 'Telephone operators',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/settings/registry_settings_form',
              '/api/referencebooks/currencies',
              '/api/referencebooks/banks',
              '/api/tariffing/suppliers',
              '/api/tariffing/tel_zones',
              '/api/referencebooks/banks',
              '/api/tariffing/time_ranges',
              '/api/settings/supplier',
              '/api/settings/tel_suppliers/service',
              '/api/settings/tel_suppliers/report_of_payments',
              '/api/settings/tel_suppliers/report_of_charges',
              '/api/settings/tel_suppliers/report_of_users',
              '/api/settings/tel_suppliers/report_of_invoices',
              '/api/settings/make_payment_for_supplier'
            ],
            post: [
              '/api/settings/suppliers_full',
              '/api/settings/suppliers',
              '/api/settings/tel_suppliers/service'
            ],
            put: [
              '/api/tariffing/get_tel_directions',
              '/api/settings/suppliers',
              '/api/settings/tel_suppliers/service'
            ],
            delete: [
              '/api/settings/suppliers'
            ]
          }
        },
        {
          name: 'Zones',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/tel_zones',
              '/api/tariffing/tel_zone'
            ],
            post: [
              '/api/tariffing/tel_zone'
            ],
            put: [
              '/api/tariffing/get_tel_directions',
              '/api/tariffing/tel_direction',
              '/api/tariffing/tel_zone'
            ],
            delete: [
              '/api/tariffing/tel_zone'
            ]
          }
        },
        {
          name: 'Directions',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/tariffing/tel_zones',
              '/api/tariffing/tel_direction'
            ],
            post: [
              '/api/tariffing/get_tel_directions',
              '/api/tariffing/tel_direction'
            ],
            put: [
              '/api/tariffing/get_tel_directions',
              '/api/tariffing/tel_direction'
            ],
            delete: [
              '/api/tariffing/tel_direction'
            ]
          }
        },
        {
          name: 'Telephone numbers',
          is_allowed: false,
          rest_api: {
            get: [
              '/api/users/tel_numbers',
              '/api/reports/tel_numbers'
            ]
          }
        }
      ]
    }
  ]
}

var getters = {
  INIT_WEB_TAB_ITEMS: (state) => {
    return state.initWebTabItems
  },
  SYSTEM_GROUPS: (state) => {
    return state.systemGroups
  },
  INFO_GROUP: (state) => {
    return state.infoGroup
  },
  FIDS: (state) => {
    return state.fids
  }
}

var mutations = {
  SET_SYSTEM_GROUPS: (state, payload) => {
    state.systemGroups = payload
  },
  SET_INFO_GROUP: (state, payload) => {
    state.infoGroup = payload
  },
  SET_FIDS: (state, payload) => {
    state.fids = payload
  }
}

var actions = {
  GET_SYSTEM_GROUPS: async (context, payload) => {
    let result = await axiosInstance.get('/users/system_groups')
    if (result.status === 200) {
      context.commit('SET_SYSTEM_GROUPS', result.data)
    }
  },
  CREATE_SYSTEM_GROUPS: (context, payload) => {
    return axiosInstance.post('/users/system_groups', payload)
  },
  UPDATE_SYSTEM_GROUPS: (context, payload) => {
    return axiosInstance.put('/users/system_groups', payload)
  },
  GET_INFO_GROUP: async (context, payload) => {
    let result = await axiosInstance.get('/users/system_group?sys_group_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_INFO_GROUP', result.data)
    }
  },
  GET_FIDS: async (context, payload) => {
    let result = await axiosInstance.get('/users/fids')
    if (result.status === 200) {
      context.commit('SET_FIDS', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/systemGroups.js